import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import utils from 'helpers/utils';
import { colors } from 'theme/theme';

const CheckBoxWrapper = styled.div`
    display: flex;
    justify-content: space-between;
`;

const Checkbox = styled.label`
    padding: 12px 24px;
    text-align: center;
    font-size: 13px;
    border: 1px solid #ccc;
    border-radius: 4px;
    cursor: pointer;

    input {
        display: none;
    }

    &:hover {
        border: 1px solid #338885;
    }
`;

const Title = styled.label`
    font-size: 12px;
    line-height: 22px;
    color: ${ (props) => {
        if (props.error) {
            return 'rgb(244, 67, 54)';
        }

        if (props.warning) {
            return '#FF8D05';
        }

        return 'rgb(102, 102, 102)';
    } }
`;

const CheckboxGroup = (props) => {
    const checkboxGroup = () => {
        const {
            input,
            options,
        } = props;

        const activeStyle = {
            backgroundColor: '#338885',
            border: '1px solid #338885',
            color: colors.white,
        };

        return options.map((option) => {
            const isActive = input.value.indexOf(option.value) !== -1;

            return (
                <Checkbox style={ isActive ? activeStyle : null } key={ option.value }>
                    <input type='checkbox'
                        name={ `${ input.name }[${ option.value }]` }
                        value={ option.value }
                        checked={ isActive }
                        onChange={ (event) => {

                            const newValue = [
                                ...input.value,
                            ];

                            if (event.target.checked) {
                                newValue.push(option.value);
                            } else {
                                newValue.splice(newValue.indexOf(option.value), 1);
                            }

                            if (utils.isEmpty(newValue)) {
                                return input.onChange(null);
                            }

                            return input.onChange(newValue);
                        } }/>

                    {option.label}
                </Checkbox>
            );
        });
    };

    const {
        checkboxGroupClass,
        label,
        meta: { error, touched },
    } = props;

    return (
        <div className={ checkboxGroupClass }>
            <Title>{ label }</Title>

            <CheckBoxWrapper>
                {
                    checkboxGroup()
                }
            </CheckBoxWrapper>

            { (touched && error) &&
                <div style={ {
                    color: 'red',
                    fontStyle: 'italic',
                    margin: '5px 0 0 40px',
                } }>
                    { error }
                </div>
            }
        </div>
    );

};

CheckboxGroup.propTypes = {
    checkboxGroupClass: PropTypes.string,
    input: PropTypes.object.isRequired,
    label: PropTypes.string,
    meta: PropTypes.shape({
        error: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.string,
        ]),
        touched: PropTypes.bool,
    }),
    options: PropTypes.array.isRequired,
};

export default CheckboxGroup;


// WEBPACK FOOTER //
// ./src/components/form/InputFields/CheckboxGroup.js